import React from 'react'

import logo from '%/assets/images/logo.png'

export default () => <img src={logo} alt="Continuous Learning Institute" />
